import { takeLatest, call, select } from 'redux-saga/effects';
import React from 'react';
import ReactDOM from 'react-dom';
import safeSaga from '../safeSaga';
import { PREVIEW_ERROR_ACTIONS } from '../../reducers/errorGroups';
import isPreviewProduct from '../../utils/isPreviewProduct';
import {
  HIDE_ELEMENTS_PREVIEW_LIST, PREVIEW_SELECTORS,
  PREVIEW_PRODUCT_TITLE, PREVIEW_PRODUCT_BRAND,
  PREVIEW_LIFECYCLE_EVENTS, PREVIEW_TITLE
} from './constants';
import { productSelector } from '../../selectors/product/productSelector';
import InternalNotificationBanner from '../../components/InternalNotificationBanner';

const removeChildrenByDataComponent = (substrings) => {
  substrings.forEach((substring) => {
    // Select all divs with data-component substring
    const elements = document.querySelectorAll(`div[data-component*="${substring}"]`);
    elements.forEach((element) => {
      while (element.firstChild) {
        element.removeChild(element.firstChild);
      }
    });
  });
};

const PREVIEW_BANNER_ROOT_KEY = 'previewBannerRoot';

// React (loaded globally from CDN on the host page) may be v16 or v18/19 depending on the
// page, regardless of the version this component is built/tested against locally. Feature-detect
// createRoot on the runtime ReactDOM object rather than importing 'react-dom/client', which does
// not exist in React 16's react-dom package.
const renderBanner = (node, element) => {
  if (typeof ReactDOM.createRoot === 'function') {
    const root = ReactDOM.createRoot(node);
    root.render(element);
    return root;
  }
  ReactDOM.render(element, node);
  return { unmount: () => ReactDOM.unmountComponentAtNode(node) };
};

const handlePreview = function* () {
  LIFE_CYCLE_EVENT_BUS.trigger(PREVIEW_LIFECYCLE_EVENTS.CONFIGURATOR.CHOICE_SELECTED_EVENT, {
    configuredProductLabel: PREVIEW_PRODUCT_TITLE,
  });

  removeChildrenByDataComponent(HIDE_ELEMENTS_PREVIEW_LIST);

  const productDetails = document.querySelector(PREVIEW_SELECTORS.PRODUCT_DETAILS);
  if (productDetails) {
    const newSpan = document.createElement('span');
    newSpan.textContent = PREVIEW_PRODUCT_BRAND;
    productDetails.appendChild(newSpan);
  }

  // Hide product-info-bar number
  const productInfo = document.querySelector(PREVIEW_SELECTORS.PRODUCT_INFO_BAR);
  if (productInfo) {
    productInfo.style.display = 'none';
  }

  // Hide magic apron assistant
  const magicApronAssistant = document.getElementById('magic-apron-assistant');
  if (magicApronAssistant) {
    magicApronAssistant.style.display = 'none';
  }

  // Not stable.... something it hide sometime it not

  // // Hide sprinklr chat
  // const sprinklrChat = document.getElementById('spr-live-chat-app');
  // if (sprinklrChat) {
  //   sprinklrChat.style.display = 'none';
  // }

  // // Hide QSI feedback link
  // const qsiFeedbackLink = document.querySelector('.QSIFeedBackLink');
  // if (qsiFeedbackLink) {
  //   qsiFeedbackLink.style.display = 'none';
  // }

  // Check if the internal-notification-banner already exists
  // On some error scenarios, it isn't created so we need to create and render the component
  const internalNotificationBanner = document.querySelectorAll(PREVIEW_SELECTORS.INTERNAL_NOTIFICATION_BANNER);
  const previewSagaNotificationBannerId = 'internal-notification-banner-div';
  if (internalNotificationBanner.length === 0) {
    const notificationBanner = document.createElement('div');
    notificationBanner.id = previewSagaNotificationBannerId;
    document.body.appendChild(notificationBanner);
    const { details } = yield select(productSelector);

    const node = document.getElementById(previewSagaNotificationBannerId);
    if (node) {
      node[PREVIEW_BANNER_ROOT_KEY] = renderBanner(node, <InternalNotificationBanner details={details} isPreview />);
    }
  } else if (internalNotificationBanner.length > 1) {
    // Remove all duplicate banners if more than one exists created by Preview Saga
    const banners = document.querySelectorAll(`#${previewSagaNotificationBannerId}`);
    banners.forEach((banner) => {
      if (banner[PREVIEW_BANNER_ROOT_KEY]) {
        banner[PREVIEW_BANNER_ROOT_KEY].unmount();
      }
      banner.parentNode.removeChild(banner);
    });
  }

  // Hide all the sections outside of the product-configurator
  document.querySelectorAll('section').forEach((section) => {
    if (!section.closest(PREVIEW_SELECTORS.PRODUCT_CONFIGURATOR)) {
      const sectionToModify = section;
      sectionToModify.style.display = 'none';
    }
  });
  // Update the browser tab title
  document.title = PREVIEW_TITLE;
};

function* hideComponent() {
  if (isPreviewProduct) {
    yield call(handlePreview);
  }
}

export default function* previewSaga() {
  yield takeLatest(
    PREVIEW_ERROR_ACTIONS,
    safeSaga(hideComponent)
  );
}
